export const PROFILE_URL='https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg'
// export const GEMINI_AI_KEY=process.env.REACT_APP_KEY